const initState={};

const BlinkerReducer = (state = initState, action) => {
    switch(action.type) {
        case  'Blinker' : return  action.payload;
        default: return state;
    }
}
export default BlinkerReducer;